import React from "react";

// COMPONENTS
import Footer from "../components/utils/Footer";

export default function TermsConditionsView() {
	return (
		<section
			className="reading-section scrollable-container"
			style={{
				overflowY: "scroll",
			}}
		>
			<header>
				<div class="header-area header-transparrent">
					<div class="main-header header-sticky">
						<div class="container">
							<div class="row align-items-center">
								<div class="col-xl-2 col-lg-2 col-md-1">
									<div class="logo">
										<a href="https://keeano.com/">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="93"
												height="20"
												viewBox="0 0 93 20"
											>
												<title
													style={{
														backgroundColor: "transparent",
														border: "none",
													}}
												>
													keeano
												</title>
												<g fill="none" R="evenodd">
													<g fill="#222C4B" fillRule="nonzero">
														<g>
															<path
																d="M70.392 4.62c-1.568-.032-3.059.683-4.015 1.926l-.077.1v-1.76h-2.473v14.78h2.57v-8.35c0-2.757 1.455-4.34 3.988-4.34 2.4 0 3.293 1.082 3.293 3.989v8.704h2.578v-8.704c0-2.067-.473-3.648-1.408-4.697-.974-1.093-2.47-1.647-4.456-1.647zM86.02 4.567c-4.276 0-6.933 2.956-6.933 7.714 0 4.758 2.657 7.713 6.932 7.713 4.276 0 6.936-2.955 6.936-7.713s-2.657-7.714-6.936-7.714zm0 13.019c-2.73 0-4.362-1.985-4.362-5.305 0-3.32 1.631-5.304 4.361-5.304 2.73 0 4.364 1.985 4.364 5.304 0 3.32-1.632 5.305-4.364 5.305zM7.393 11.495c.742-.563 1.421-1.202 2.028-1.907 1.15-1.364 2.08-2.898 2.756-4.55l.077-.178H9.482l-.035.074C8.32 7.247 6.827 8.968 5.01 10.049c-.727.44-1.52.76-2.35.945l-.052.01V0H0v19.658h2.608v-6.082h.038c.863-.122 1.698-.39 2.472-.79l.034-.016 4.886 6.893h3.16L7.36 11.519l.033-.024zM20.956 4.567c-2.193 0-4.03.742-5.31 2.147-1.258 1.374-1.922 3.321-1.922 5.622 0 2.259.658 4.169 1.901 5.526 1.28 1.394 3.123 2.138 5.33 2.138 3.032 0 5.406-1.496 6.526-4.106l-2.439-.849c-.086.176-.179.347-.235.458-.819 1.374-2.15 2.09-3.857 2.09-2.553 0-4.276-1.624-4.613-4.345v-.049h11.82v-.863c0-4.72-2.826-7.769-7.201-7.769zm-4.499 6.213l.013-.052c.48-2.348 2.159-3.751 4.486-3.751 2.29 0 3.952 1.403 4.456 3.751l.012.052h-8.967zM37.716 4.567c-2.195 0-4.031.742-5.313 2.147-1.256 1.374-1.919 3.321-1.919 5.622 0 2.259.657 4.169 1.9 5.526C33.664 19.256 35.506 20 37.716 20c3.022 0 5.394-1.489 6.517-4.088l-2.436-.844c-.085.176-.177.345-.227.44-.814 1.363-2.147 2.084-3.854 2.084-2.555 0-4.276-1.625-4.613-4.346v-.049h11.82v-.86c-.002-4.72-2.828-7.77-7.207-7.77zm-4.494 6.213l.01-.052c.485-2.348 2.163-3.751 4.484-3.751 2.29 0 3.95 1.403 4.457 3.751l.01.052h-8.961zM59.97 16.612v-6.456c0-1.799-.631-3.262-1.833-4.233-1.092-.887-2.63-1.356-4.443-1.356-2.947 0-4.974 1.927-5.813 3.578l-.061.119 2.22 1.041.058-.107c.232-.404.511-.78.83-1.12.743-.775 1.777-1.203 2.85-1.18 2.348 0 3.615 1.264 3.615 2.453v.18c-.062.816-2.256 1.187-4.086 1.356-1.895.18-3.391.672-4.445 1.463-1.14.86-1.72 1.968-1.72 3.294 0 2.65 1.914 4.3 4.996 4.3 2.525 0 4.275-.683 5.358-2.085l.049-.064.026.078c.378 1.159 1.423 1.797 2.94 1.797h.585v-2.415h-.61c-.477 0-.517-.49-.517-.643zm-2.57-4.244c0 1.782-.413 3.07-1.242 3.934-.829.864-2.052 1.278-3.747 1.278-1.585 0-2.693-.799-2.693-1.942 0-1.453 1.128-2.138 4.025-2.454 1.714-.18 2.89-.338 3.588-.85l.069-.051v.085z"
																transform="translate(-32.000000, -18.000000) translate(32.000000, 18.000000)"
															></path>
														</g>
													</g>
												</g>
											</svg>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>

			<main>
				<div class="coverage section-padding">
					<div class="container">
						<div class="row">
							<div class="col-md-12 mx-auto">
								<div style={{ margintop: "6rem" }}>
									<h1>Terms of Use</h1>
								</div>
								<p>
									Please read carefully each provision of this Terms of Use
									&amp; License agreement (collectively, the “Agreement”) as it
									sets forth the legally binding terms and conditions for your
									use of Keeano App (“Keeano App” or the “App”). The use of
									Keeano App and any of its content, services and features
									(collectively the “Services”), as defined below, is subject to
									your prior express acceptance of these terms.
								</p>
								<p>Table of contents:</p>
								<ol>
									<li>Introduction</li>
									<li>Registration and account</li>
									<li>Profile</li>
									<li>Personal Data</li>
									<li>License of use</li>
									<li>Paid services and payments</li>
									<li>Cancellation of payment</li>
									<li>Exclusion of liability - Lack of guarantee</li>
									<li>Inappropriate use</li>
									<li>Suspension and termination</li>
									<li>Trademarks and Intellectual Property rights</li>
									<li>Third parties’ links</li>
									<li>Liability</li>
									<li>Applicable law</li>
									<li>Changes</li>
								</ol>
								<h5>1. Introduction</h5>
								<p>
									By using Keeano App you are entering into a legally binding
									agreement with KEEANO LTD, Nicosia, Cyprus, doing business as
									Keeano, (“Keeano,” “we,” “us,” or “our”). We are a limited
									company, registered in Cyprus and our registered office is at
									Nicosia, Metochiou 73. Our Services are comprised of our
									mobile application, “Keeano App”, any interactive feature or
									other software and any information provided or made available
									by us and our website, available at: https://keeano.com
									(including any versions optimized for viewing on a wireless or
									tablet device).
								</p>
								<p style={{ fontStyle: "italic" }}>
									Keeano is changing the way boaters - travelers explore,
									navigate and experience the coastlines around Mediterranean
									Sea. We provide smart subscription-based services for bareboat
									travelers, skippers, charter companies and coastal travel
									enthusiasts. We help create travelers’ communities that work
									together to improve the quality of everyone’s daily trip
									planning. That could mean helping the ‘loners’ avoid crowded
									beaches, or boaters avoid unsuitable anchorages.
									<br />
									In addition to the communities of travelers using the app,
									keeano is also home to an active community of online map
									editors who ensure that the data in their areas is up-to-date.
								</p>
								<h5>2. Registration and account</h5>
								<p>
									In order to use Keeano App and our Services you shall register
									with us either by creating your Keeano account or by using
									your Facebook or Gmail account. At your registration, you are
									requested to provide Keeano only the necessary of your
									personal information in order for your personal account to be
									created (such information being the “Registration Data”),
									namely your name and surname as well as your email and
									personal password. As a registered user, you expressly
									represent and agree that you are of legal age to form a
									binding contract in your jurisdiction of residence and the
									sole render of our Services. If you are registering on behalf
									of an entity, you expressly represent and warrant that you are
									authorized to enter into. You understand that you shall
									provide true and accurate information about you and that you
									shall promptly update your Registration Data to keep it true
									and accurate. Keeano reserves the right to suspend or
									terminate your account and refuse any and all our Services at
									any time and without previous notice, in case we have
									reasonable grounds to suspect that such information is untrue.
									You are personally and solely responsible for all activities
									and any transaction made through your account, as well as for
									the security and the confidentiality of your password. You
									should immediately notify us of any unauthorized use of your
									account or for any breach of security that you may become
									aware of.
								</p>
								<p>
									If you wish to deactivate your account with Keeano you can do
									it at any time by clicking “Delete my account” in
									application’s settings screen
								</p>
								<h5>3. Profile</h5>
								<p>
									After registering with us, you may provide us with additional
									information regarding your preferences and/or your personal
									interests and needs and your transportation type so that you
									will enjoy our advanced personalized Services such as place
									filtering and suitability, weather data etc. Your profile
									information such as name, surname and profile image are
									visible within the Keeano application community. You can turn
									your profile private, by un-checking “Public Profile” in
									application’s settings screen.
								</p>
								<h5>4. Personal Data</h5>
								<p>
									Any and all of your personal information, including but not
									limited to names, email addresses, addresses, your location
									will be collected and kept by Keeano in accordance with its
									<a
										class="alink"
										href="https://keeano.com/privacy-policy.html"
									>
										Privacy Policy
									</a>
									.
								</p>
								<h5>5. License of use</h5>
								<p>
									According to the terms of this Agreement, as well as Keeano’s
									Privacy Policy and any additional terms, Keeano grants you a
									non-exclusive, non-assignable, non-transferrable and revocable
									license to view, display and use Keeano App, including its
									content, services and features, on your mobile device or other
									device for your personal use only. This license does not
									include or provide any right of commercial use of the App.
									Except as expressly permitted herein, Keeano App and/or any
									portion of its Services may not be reproduced, sold, resold,
									visited or otherwise exploited for any other purpose without
									Keeano’s express written consent.
								</p>
								<h5>6. Paid services, payments and free trials</h5>
								<p>Keeano App is available to you for free.</p>
								<h5>7. Cancellation of payment</h5>
								<h5>8. Exclusion of liability - Lack of guarantee</h5>
								<p>
									Keeano makes commercially reasonable efforts and takes
									commercially reasonable measures to provide its Services to
									you on a 24-hour basis, but does not guarantee that our
									services will be available to you at all times. We provide our
									services on an “as is” basis. Keeano does not provide any type
									of guarantee neither is responsible for the correctness,
									validity and accuracy of any information published on Keeano
									App, nor for the suitability of their usage for purposes other
									than informational only.
								</p>
								<p>
									Keeano does not represent or bear any responsibility for any
									submission or published content of its users. Keeano does not
									vouch for the accuracy or credibility of any published content
									of its users on Keeano App or any user’s submission published
									through the App, and does not take any responsibility or
									assume any liability for any actions you may take as a result
									of reviewing any such users’ published content. Please note
									that during your experience with Keeano App you may be exposed
									to content that you may find inaccurate, deceptive, offensive
									or even harmful.
								</p>
								<p>
									Keeano offers no guarantee that the Services, functions and
									content of the App will be provided without interruption or
									without errors or that the App or the servers through which it
									becomes available to you do not contain viruses or other
									harmful components, although we make every effort to ensure
									it.
								</p>
								<h5>9. Inappropriate use</h5>
								<p>
									You shall not use Keeano App or any of our Services to post or
									send any unlawful, infringing, defamatory, threatening,
									pornographic or profane material or any material that may
									infringe third party’s intellectual property, or may
									constitute or encourage conduct that would be considered
									violating any law. You shall not post, upload or make any
									comment that may inflict emotional distress on other Keeano
									users or people, or offend or humiliate other Keeano users or
									other people. You agree that you will not send or post
									unsolicited advertisements or ‘spam’ on or through our
									Services or use any robot, spider or other automated means to
									access Keeano App for any purpose without our prior written
									consent.
								</p>
								<p>
									Keeano reserves the right, at its sole and absolute
									discretion, to take any action considered necessary to prevent
									or cure any violation, in case we determine that you have
									violated or you are likely to violate any of the present
									term’s prohibitions or any other term of this Agreement. In
									this case, Keeano may immediately, without any further notice,
									remove any inappropriate content or material from the App, or
									even ban you form using our Services.
								</p>
								<h5>10. Suspension and termination</h5>
								<p>
									We may, from time to time, with or without prior notice,
									temporarily suspend the operation of any of our Services or
									features (in whole or in part), either for maintenance
									purposes or in order to update or upgrade any contents,
									features or functionality of Keeano App. We may also from time
									to time, with or without prior notice, at our sole and
									absolute discretion, make additions to, modifications to the
									format and features of Keeano App or even terminate any of our
									Services.
								</p>
								<p>
									We may, with or without prior notice, suspend and/or terminate
									your use of your account in the event that you have breached
									any of these terms or you fail to pay any correctly billed
									charges when due. In this case, depending on the kind of your
									breach, we may issue a prior warning to you or even take all
									legal proceedings against you for any damages or loss
									incurred. Upon termination of your account for any reason all
									rights granted to you under this Agreement will immediately
									cease and you must promptly discontinue all use of Keeano App.
								</p>
								<h5>11. Trademarks and Intellectual Property rights</h5>
								<p>
									All of the content featured or displayed on Keeano App and all
									marks or elements of our Services, including without
									limitation to text, graphics, images and illustrations, source
									codes, software, designs, and all and any registered trademark
									and trade name of Keeano used herein, are owned by Keeano and
									are protected by copyright, trademark, moral rights and other
									laws relating to intellectual property rights. You may not
									copy, reproduce, republish, furnish, create derivatives of,
									transmit, display, post, upload, modify, distribute or in any
									other way use or exploit Keeano’s trademarks or copyrights or
									other intellectual property rights, without Keeano’s prior
									written consent. You shall not copy or remove any trademark,
									copyright or other proprietary notices from the App or our
									Services and features.
								</p>
								<p>
									You expressly understand and acknowledge that Keeano’s trade
									name, registered trademarks, copyrights and any intellectual
									property regarding the App and our Services shall all remain
									the exclusive property of Keeano or its affiliates,
									subsidiaries, agents etc.
								</p>
								<p>
									Keeano reserves the right to provide access to user’s posts or
									photos to third parties through the App. The third party does
									not acquire any right to the posts or photographs and can only
									display them by using Keeano App.
								</p>
								<h5>12. Third parties’ links</h5>
								<p>
									Keeano App may from time to time contain links that lead to
									other apps or websites, which are not owned, operated or
									controlled by Keeano. These apps or websites are owned and
									controlled by third parties, and under no circumstances will
									Keeano be liable for their content, privacy policies or
									practices, or for any financial or other type of loss or
									damage that you may sustain following those links. You
									understand and agree that following these links is subject to
									your personal and sole consent and that Keeano does not
									control third parties’ services. You are encouraged to read
									all policies and information on the applicable third parties’
									services to learn more about how they operate and handle your
									information, before using any such features made available to
									you. In no case does Keeano guarantee that these links will be
									temporarily or constantly active.
								</p>
								<p>
									Keeano is not responsible for any communication between you
									and third service providers being advertised on the App or for
									any commercial transaction that may arise from this
									communication. We reserve the right to remove or add links
									without any warning to any party and to change the contents of
									the App on this matter at any time.
								</p>
								<h5>13. Liability</h5>
								<p>
									Keeano and any of its affiliates shall not be liable or
									responsible in negligence or otherwise to any person not a
									party to this Agreement for any information or advice
									expressly or impliedly given by Keeano, or any act, omission
									or inaccuracy by Keeano.
								</p>
								<p>
									Nothing in this Agreement will be construed to create any
									rights in favor of any person not a party to this Agreement
									other than Keeano and you. You shall, at your expense,
									indemnify, defend, and hold Keeano and our affiliates harmless
									from and against any and all claims, losses, liabilities,
									damages, actions, proceedings, costs, and expenses arising out
									of or relating to your use of our App and Services or your
									breach of this Agreement.
								</p>
								<h5>14. Changes</h5>
								<p>
									Keeano reserves the right at any time to change or update this
									Agreement without notice. We will post any revision to these
									terms, so we recommend that you read carefully any such
									notification for change in our terms.
								</p>
								<p>
									If you disagree with any changes in this Agreement and you do
									no more wish to be subject to the revised Terms of Use, you
									will need to deactivate your account by clicking by clicking
									“Delete my account” in application’s settings screen.
								</p>
								<h5>15. Applicable law</h5>
								<p>
									All the above mentioned terms are considered as essential.
									Should any of these terms become against the law, it becomes
									inactive and is removed from this Agreement without affecting
									in any way the validity of the other terms. This Agreement
									with any modification or alteration on them, as well as any
									additional terms are subject to the laws of the Republic of
									Cyprus. If any dispute or difference arises out of or in
									connection with this Agreement or Keeano App and its Services,
									it shall be resolved by the courts of Nicosia Cyprus which
									shall have exclusive jurisdiction.
								</p>
								<p>
									<strong>
										If you have any questions in this Agreement or our Services,
										please contact us at
										<a class="alink" href="mailto:support@keeano.zendesk.com">
											support@keeano.com
										</a>
									</strong>
								</p>
								<p>
									<strong>
										To exercise your right of withdrawal, you can use the
										following link or inform us at
										<a class="alink" href="mailto:support@keeano.zendesk.com">
											support@keeano.com
										</a>
									</strong>
								</p>
								<p>
									<strong>
										If you disagree with the present Terms of Use you should not
										use Keeano app.
									</strong>
								</p>
							</div>
						</div>
					</div>
				</div>
			</main>

			<div className="container" style={{}}>
				<Footer />
			</div>
		</section>
	);
}
